<template>
    <router-view :user="user"></router-view>
</template>

<script lang="js">
export default {
    name: 'BackofficeLayout',
    data: () => ({
        user: {
            id: null,
            prenom: '',
            nom: '',
            matricule: '',
            etablissement_libelle: '',
            etablissement: null,
            etablissement_id: 0,
            role: '',
            email: ''
        },
    }),
    methods: {
        async fetchUser() {
            try {
                const response = await axios.get('user');
                const rawPayload = response && response.data ? response.data : response;
                const userData = rawPayload && rawPayload.data && typeof rawPayload.data === 'object' && !Array.isArray(rawPayload.data)
                    ? rawPayload.data
                    : rawPayload;

                const normalizedUser = {
                    id: null,
                    prenom: '',
                    nom: '',
                    matricule: '',
                    etablissement_libelle: '',
                    etablissement: null,
                    etablissement_id: 0,
                    role: '',
                    email: ''
                };

                this.user = {
                    ...normalizedUser,
                    ...(userData || {})
                };

                this.$store.commit('auth/SET_LOGGED', { user: this.user, isLoggedIn: true });
            } catch (err) {
                const message = err && err.message ? err.message : 'Impossible de charger l’utilisateur.';
                this.$swal({
                    icon: 'error',
                    title: 'Erreur',
                    text: message
                });
            }
        },
    },

    created() {
        this.fetchUser()
    }
};
</script>
